import { C, P0, S, abs, arc, fillAt, max, rotPts } from '../../geometry';

export const planet = {
  name: 'Planet',
  colors: ['#3E63DD', '#E3A008'],
  draw(m, t) {
    let tilt = -20 + 3 * S(t * 0.8),
      rx = 38,
      ry = 9,
      k = 1,
      moonO = 0,
      moonA = 0.5,
      pose = P0();
    if (m === 'happy') {
      tilt = -20 + 10 * S(t * 6);
      pose.ty = -2 * abs(S(t * 6));
    }
    // Thinking: the ring rocks and a moon keeps gliding along its front.
    if (m === 'thinking') {
      tilt = -20 + 12 * S(t * 1.4);
      moonO = 1;
      moonA = 0.12 + 0.76 * (0.5 + 0.5 * S(t * 2.2));
    }
    if (m === 'talking') ry = 9 + 4 * max(0, S(t * 10));
    if (m === 'surprised') {
      rx = 44;
      ry = 12;
      k = 1.08;
    }
    if (m === 'paused') {
      tilt = -6;
      ry = 3.5;
      rx = 36;
    }
    const E = (a) =>
      rotPts([[50 + rx * C(a), 54 + ry * S(a)]], 50, 54, tilt)[0];
    const back = [...Array(12)].map((_, i) => E(Math.PI + (i / 11) * Math.PI)),
      front = [...Array(12)].map((_, i) => E((i / 11) * Math.PI));
    const mp = E(moonA * Math.PI);
    return {
      strokes: [
        { c: 'b', pts: back },
        { c: 'a', pts: arc(50, 52, 21 * k, -90, 270, 17), n: 24 },
        { c: 'b', pts: front },
        { c: 'b', pts: [mp, [mp[0] + 0.01, mp[1]]], o: moonO },
      ],
      eyes: { x: 50, y: 47 },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 1),
};
